module.exports = __webpack_public_path__ + "static/img/zxlnxsqk.5164259f.png";